module.exports = __webpack_public_path__ + "img/1481919190.53f360c3.jpg";